import { HELPER_SCRIPTS } from './helper-scripts';

/**
 * Project Bobcat (`bobcat-agent-templates`) — a placeholder action script for
 * a command an agent template or an AI draft uses before anyone has written
 * the real one. It is honest about it: it logs that it is not connected and
 * answers the decision variable with "false", so the agent takes its
 * not-found path ("Try again" / "Talk to a person") instead of the solution
 * failing to publish over a missing script. The agent's own "still to
 * connect" note says to replace it.
 */
export const placeholderScript = (
  command: string,
  decisionVariable: string,
  answer = 'false'
): string =>
  // A helper every solution shares is uploaded for real, not as a stand-in.
  HELPER_SCRIPTS[command] ??
  [
    `class ${command}:`,
    '    """Placeholder added by Pro Studio when it built this agent.',
    '',
    `    Not connected to any system yet: it always answers`,
    `    {"${decisionVariable}": "${answer}"}${
      answer === 'false'
        ? ', so the agent offers to try again or\n    hand the customer to a person.'
        : ', so the flow carries on as if it\n    succeeded.'
    } Replace it with the real script, in Actions."""`,
    '',
    '    def execute(self, log, payload=None, context=None):',
    `        log("${command} is a placeholder and is not connected to a system yet.")`,
    `        return {"${decisionVariable}": "${answer}"}`,
    '',
  ].join('\n');
